import { defineMessages } from 'react-intl';

export default defineMessages({
  cardTitle: {
    id: 'homeDocumentsCard.cardTitle',
    defaultMessage: 'Documenti',
  },
  descriptionDocumentsCardFirstPart: {
    id: 'homeDocumentsCard.descriptionDocumentsCardFirstPart',
    defaultMessage: 'Hai',
  },
  descriptionDocumentsCardSecondPart: {
    id: 'homeDocumentsCard.descriptionDocumentsCardSecondPart',
    defaultMessage: 'nuovi documenti',
  },
  buttonLabelDocumentsCard: {
    id: 'homeDocumentsCard.buttonLabelDocumentsCard',
    defaultMessage: 'Visualizza',
  },
  descriptionDocumentsCardNoDocuments: {
    id: 'homeDocumentsCard.descriptionDocumentsCardNoDocuments',
    defaultMessage: 'Non sono presenti nuovi documenti',
  },
});
